import { getCookie } from "@/utils/token";
import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/:catchAll(.*)",
    name: "Error",
    hidden: true,
    component: () => import("@/components/error.vue"),
  },
  {
    path: "/",
    name: "首页",
    redirect: "/login",
    hidden: true,
    component: () => import("@/pages/login/index.vue"),
  },
  {
    path: "/login",
    name: "登录",
    hidden: true,
    component: () => import("@/pages/login/index.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "carbon:home",
    redirect: "/dashboard/home",
    component: () => import("@/pages/container"),
    children: [
      {
        path: "/dashboard/home",
        name: "主页",
        icon: "bx:home",
        component: () => import("@/pages/dashboard/index.vue"),
      },
    ],
  },
  {
    path: "/sprite",
    name: "精灵管理",
    icon: "ci:image-alt",
    component: () => import("@/pages/container"),
    children: [
      {
        path: "/sprite/category",
        name: "精灵分类",
        icon: "carbon:category",
        component: () => import("@/pages/sprite/category.vue"),
      },
      {
        path: "/sprite/group",
        icon: "entypo:sound-mix",
        name: "精灵文件",
        component: () => import("@/pages/sprite/group.vue"),
      },
      {
        path: "/sprite/list",
        icon: "lucide:layout-list",
        name: "精灵列表",
        component: () => import("@/pages/sprite/list.vue"),
      },
    ],
  },
  {
    path: "/video",
    name: "背景管理",
    redirect: "/video/category",
    icon: "carbon:image-copy",
    component: () => import("@/pages/container"),
    children: [
      {
        path: "/video/category",
        name: "背景分类",
        icon: "icon-park-outline:category-management",
        component: () => import("@/pages/video/category.vue"),
      },
      {
        path: "/video/list",
        name: "背景列表",
        icon: "charm:layout-list",
        component: () => import("@/pages/video/list.vue"),
      },
    ],
  },
  {
    path: "/sound",
    name: "声音管理",
    icon: "fluent:headphones-sound-wave-32-regular",
    component: () => import("@/pages/container"),
    children: [
      {
        path: "/sound/category",
        name: "声音分类",
        icon: "entypo:sound-mix",
        component: () => import("@/pages/sound/category.vue"),
      },
      {
        path: "/sound/list",
        name: "声音列表",
        icon: "entypo:sound",
        component: () => import("@/pages/sound/list.vue"),
      },
    ],
  },
  {
    path: "/ai",
    name: "AI管理",
    icon: "fluent:headphones-sound-wave-32-regular",
    component: () => import("@/pages/container"),
    children: [
      {
        path: "/ai/record",
        name: "生成记录",
        icon: "entypo:sound-mix",
        component: () => import("@/pages/ai/record.vue"),
      },
      {
        path: "/ai/project",
        name: "作品库",
        icon: "bx:box",
        component: () => import("@/pages/ai/project.vue"),
      }
    ],
  },
  {
    path: "/user",
    name: "用户管理",
    icon: "carbon:user-multiple",
    component: () => import("@/pages/container"),
    children: [
      {
        path: "/user/user",
        name: "用户列表",
        icon: "heroicons-outline:user-group",
        component: () => import("@/pages/user/User.vue"),
      },
      {
        path: "/user/organization",
        name: "机构管理",
        icon: "carbon:building",
        component: () => import("@/pages/user/OrganizationManagement.vue"),
      },
      {
        path: "/user/user-management",
        name: "系统用户管理",
        icon: "carbon:user-admin",
        component: () => import("@/pages/user/UserManagement.vue"),
      },
    ],
  },
  {
    path: "/admin",
    name: "系统管理",
    icon: "clarity:administrator-line",
    component: () => import("@/pages/container"),
    children: [
      {
        path: "/admin/admin",
        name: "管理员列表",
        icon: "clarity:administrator-line",
        component: () => import("@/pages/admin/admin.vue"),
      },
      {
        path: "/admin/authority",
        name: "权限管理",
        icon: "icon-park-outline:permissions",
        component: () => import("@/pages/admin/authority.vue"),
      },
      {
        path: "/admin/version",
        name: "版本",
        icon: "icon-park-outline:file-conversion-one",
        component: () => import("@/pages/admin/version.vue"),
      },
    ],
  },
  {
    path: "/asset",
    name: "资产管理",
    redirect: "/asset/list",
    icon: "carbon:cloud-services",
    component: () => import("@/pages/container"),
    children: [
      {
        path: "/asset/list",
        name: "用户资产",
        icon: "carbon:inventory-management",
        component: () => import("@/pages/asset/index.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});
// router.beforeEach(( to, from, next) => {
//   if(to.path === '/login' || to.path === '/') {
//     next()
//   } else if(!getCookie('tokenKey')) {
//     next('/login')
//   } else next()
// })
export default router;
